module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-6c712ef1b0280c91ac63e160536e1069.png";